import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { UsuarioContext } from "../../../providers/userContext";
import { useEffect } from "react";
import { getFinca, getListarDocsFincaProv, getSales, guardarFechaDocLeido } from "../../../services";
import { toast } from "react-toastify";
import moment from "moment";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import {
  municipiosIniciales,
  cambiarFormatoNombre,
} from "../../../functions/funciones";
import { withRouter } from "../../../providers/withRouter";
import Tick from "../../../icons/tick.svg";
import Cross from "../../../icons/cross.svg";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import Documento from "../../../icons/document.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { FileText } from "lucide-react";


const Comunidad = (props) => {
  const { t } = useTranslation(['properties', 'aaff', 'common', 'suppliers']);
  const user = useContext(UsuarioContext);
  const nif = props?.params?.nifFinca ?? null;

  const [recargar, setRecargar] = useState(false);
  const [info, setInfo] = useState(0);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [listDocs, setListDocs] = useState([]);
  const [salesCae, setSalesCae] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const docsLeer = [
    { id: 1, nombre: t('documents.riskAssessment'), type: "evaluacionRiesgos" },
    { id: 2, nombre: t('documents.emergencyPlan'), type: "planEmergencia" }
  ];

  const fetchData = async () => {
    try {
      const response = await getFinca(nif);
      setInfo(response);
      const { data } = await getSales({ filtros: { prop_id: response.id }, params: {} });


      const resultadosFiltrados = data
        .filter(objeto => (objeto.servp_id === 1 || objeto.servp_id === 3 || objeto.servp_id === 6 || objeto.servp_id === 7) && objeto.detailsCae?.some(d => d.visitada))
        .shift();

      if (!resultadosFiltrados) {
        // toast.error("No se encontró ningún resultado con servp_id 1 o 3");
        setSalesCae(null);
        setListDocs([]);
        setIsLoading(false);
        return;
      }

      const respListDocs = await getListarDocsFincaProv(resultadosFiltrados.id)
      setListDocs(respListDocs);
      setSalesCae(resultadosFiltrados)

      setListadoMunicipios(
        municipiosIniciales(provinces, municipalities, response?.provincia)
      );
      setIsLoading(false);

    } catch (error) {
      console.log(error);
    }
  };
  const docLeido = async (id, doc_id) => {
    let nombre = ''
    if (id === 1) {
      nombre = 'identificacion-riesgos'
    }
    if (id === 2) {
      nombre = 'medidas-emergencia'
    }
    const ruta = `/doc-render/${props.params.nif}/${salesCae.id}/${nombre}`
    window.open(ruta, '_blank');
    await guardarFechaDocLeido(doc_id, user.id).then(setRecargar(!recargar))
  }

  useEffect(() => {
    fetchData();
  }, [recargar]);
  return isLoading ? <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
    <>
      <BreadCrumb rutas={[{ path: "/aaff", label: t('aaff:title') }, { path: `/aaff/${props.params.nif}/comunidades`, label: info?.aaff?.razonSocial }, { path: `/comunidades/${info?.nif}`, label: info?.razonSocial }]} />


      <div className="listPage">
        <div className="gridCard">
          <div
            className="gridHead"
            style={{
              backgroundColor: "#92004D",
              display: "flex",
              flexDirection: " row",
            }}
          >
            <Typography fontWeight="bold">{t('details.generalInfo')}</Typography>
          </div>
        </div>
        <Box sx={{ mb: 2 }}>
          <Box
            className="lae-flex lae-flex-column"
            sx={{
              backgroundColor: "#fff",
              padding: 2,
              mb: 1,
              borderRadius: "0 0 10px 10px",
              boxShadow: "0.1px 2px 10px rgba(0, 0, 0, 0.1)",
              padding: 0
            }}
          >
            <div className="gridSubhead editarSubhead">
              <div>{t('details.communityData')}</div>
            </div>
            <Box className="lae-flex lae-flex-row">
              <Box className="lae-flex lae-flex-column" sx={{ flex: 3.3, padding: '16px' }}>
                <Typography>{t('details.communityName')}: {info?.razonSocial}</Typography>
                <Typography>{t('details.nif')}: {info?.nif}</Typography>
                <Typography>
                  {t('details.contactPerson')}: {info?.nombreContacto}
                </Typography>
                <Typography>
                  {t('details.contactEmail')}: {info?.emailContacto}
                </Typography>
                <Typography>
                  {t('details.contactPhone')}: {info?.telefonoContacto}
                </Typography>
              </Box>
              <Box className="lae-flex lae-flex-column" sx={{ flex: 3.3 }}>
                <Typography>{t('details.address')}: {info?.direccion}</Typography>
                <Typography>{t('details.municipality')}: {cambiarFormatoNombre(info?.municipio)}</Typography>
                <Typography>{t('details.postalCode')}: {info?.codigoPostal}</Typography>
                <Typography>{t('details.province')}: {info?.provincia}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className="lae-flex lae-flex-row" sx={{ width: "100%" }}>
          <Box sx={{ flex: 1 }}>
            <div className="gridCard">
              <div className="gridHead" style={{ backgroundColor: "#92004D" }}>
                <Typography fontWeight="bold">
                  {t('details.communityDocuments')}
                </Typography>
              </div>
            </div>

            <Box
              className="lae-flex lae-flex-column"
              sx={{
                backgroundColor: "#fff",
                padding: 2,
                mb: 1,
                borderRadius: "0 0 10px 10px",
                boxShadow: "0.1px 2px 10px rgba(0, 0, 0, 0.1)",
                justifyContent: "space-between",
              }}
            >
              <Box className="lae-flex lae-flex-row">
                <Box sx={{ flex: 8 }}>
                  <picture></picture>
                  <Typography></Typography>
                </Box>
                <Box
                  className="lae-flex lae-flex-row"
                  sx={{
                    flex: 2,
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ width: '100px', textAlign: "center" }}>{t('common:table.lastRead')}</Typography>
                  <Typography style={{ width: '100px', textAlign: "center" }}>{t('common:actions.view')}</Typography>
                </Box>
              </Box>

              {Object.values(docsLeer).map((dt, i) => {
                const docCorrespondiente = listDocs?.find(doc => doc.type === dt.type);
                return (
                  <Box key={i} className="lae-flex lae-flex-row" sx={{ pr: 0.4 }}>
                    <Box sx={{ flex: 8 }} style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>
                        {salesCae?.detailsCae && salesCae?.detailsCae.length > 0 && salesCae.detailsCae[0]?.visitada ?
                          <img src={Tick} alt={t('common:status.visited')} className="tableIcon" />
                          :
                          <img src={Cross} alt={t('common:status.notVisited')} className="tableIcon" />
                        }
                      </Typography>
                      <Typography variant="body2">
                        {dt.nombre}
                      </Typography>
                    </Box>
                    <Box
                      className="lae-flex lae-flex-row"
                      sx={{
                        flex: 2,
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <Typography style={{ width: '100px', textAlign: "center" }}>
                        {docCorrespondiente?.suppRead?.[0]?.r_doc_reads?.updatedAt
                          ? moment(docCorrespondiente.suppRead[0].r_doc_reads.updatedAt).format("DD/MM/YYYY")
                          : "----"}
                      </Typography>
                      {(() => {
                        const isVisitada = salesCae?.detailsCae && salesCae?.detailsCae.length > 0 && salesCae.detailsCae[0]?.visitada;
                        return (
                          <FileText
                            src={Documento}
                            alt={t('common:actions.view')}
                            className="tableIcon"
                            style={{ color: isVisitada ? "black" : "gray", cursor: isVisitada ? "pointer" : "default" }}
                            onClick={() => isVisitada ? docLeido(dt.id, docCorrespondiente?.id, docCorrespondiente?.suppRead?.[0]?.r_doc_reads) : null}
                          />
                        );
                      })()}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      </div>
    </>

};

export default withRouter(Comunidad);
